import * as React from 'react';
import { EXPORT_STATUS } from '@innovyze/stylovyze/lib/types';
import { ExportDialog } from '@innovyze/stylovyze/lib/components';
export const ExportDialogRenderProps = ({ children, total, requestParams, source, maxRows = 100000, dialogDataCy = 'export-dialog', maxPollAttempts = 10, iterationTime = 5000, messages, }) => {
    const [open, setOpen] = React.useState(false);
    const validExport = React.useMemo(() => total <= maxRows, [total, maxRows]);
    const initialExportResult = {
        _id: '',
        requestParams: requestParams,
        status: validExport ? EXPORT_STATUS.IDLE : EXPORT_STATUS.INVALID,
    };
    const [exportResult, setExportResult] = React.useState(initialExportResult);
    const handleExport = () => {
        setExportResult(initialExportResult);
        setOpen(true);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(ExportDialog, { open: open, setOpen: setOpen, total: total, source: source, requestParams: requestParams, maxRows: maxRows, dataCy: dialogDataCy, exportResult: exportResult, setExportResult: setExportResult, maxPollAttempts: maxPollAttempts, iterationTime: iterationTime, messages: messages }),
        children({
            exportResult,
            handleOpenExport: handleExport,
            setOpen,
            open,
        })));
};
